import template from './rnLink.html';
import { OTVOREN, UOBRADI, ZAKLJUCAN, STORNIRAN } from './statusi.js';

const status = {};
status[OTVOREN] = 'btn-success';
status[UOBRADI] = 'btn-info';
status[ZAKLJUCAN] = 'btn-danger';
status[STORNIRAN] = 'btn-default';

class RnLinkController {
    constructor() {}

    $onInit() {
        this.style = status[this.rn.status];
    }
}

RnLinkController.$inject = [];

const RnLinkComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: RnLinkController,
    controllerAs: 'vm',
    bindings: {
        rn: '<',
        badge: '<'
    }
};

export { RnLinkComponent };
export { RnLinkController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/rnLink.component.js